// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__UdRzG","questions":"styles_questions__BQwYY","faq__img":"styles_faq__img__9_wWL"};